<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">Service Master</h1>
    <div class="form shadow p-4 mb-5 bg-white rounded no-margin-rows">
      <div class="row">
        <div class="col-6">
          <BrandDropdown
            v-model="form.brandSelected"
            @setBrand="setBrand"
            @setBrands="setBrands"
            required="true"
            :setDisable="Number.isInteger(this.id)"
          ></BrandDropdown>
          <div v-if="isSubmit && error.errorBrandCode" class="text-error">
            {{ error.errorBrandCode.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="nameThBox"
            >Name (TH)<span class="required">*</span></label
          >
          <input
            id="nameThBox"
            v-model="form.nameTh"
            type="text"
            class="form-control"
          />
          <div v-if="isSubmit && error.errorNameTh" class="text-error">
            {{ error.errorNameTh.message }}
          </div>
        </div>
        <div class="col">
          <label for="nameEnBox"
            >Name (EN)<span class="required">*</span></label
          >
          <input
            id="nameEnBox"
            v-model="form.nameEn"
            type="text"
            class="form-control"
          />
          <div v-if="isSubmit && error.errorNameEn" class="text-error">
            {{ error.errorNameEn.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="detailThBox">Detail (TH)</label>
          <textarea
            id="detailThBox"
            v-model="form.detailTh"
            class="form-control"
            rows="4"
          ></textarea>
        </div>
        <div class="col">
          <label for="detailEnBox">Detail (EN)</label>
          <textarea
            id="detailEnBox"
            v-model="form.detailEn"
            class="form-control"
            rows="4"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label for="durationBox"
            >Reserved duration (Minutes) หาร 15 ลงตัว<span class="required"
              >*</span
            >
          </label>
          <NumberInput input-id="durationBox" v-model.number="durationInMinutes" :is-decimal-allowed="true"/>
          <div v-if="isSubmit && error.errorDuration" class="text-error">
            {{ error.errorDuration.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex flex-row">
            <input
              class="form-check-input mr-2"
              id="isActive"
              type="checkbox"
              v-model="form.status"
              :class="{
                'input--error': isSubmit && error.errorStatus,
              }"
            />
            <label class="form-check-label" for="isActive"> Active </label>
          </div>
          <div v-if="isSubmit && error.errorStatus" class="text-error">
            {{ error.errorStatus.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <label for="startDatePicker" required
            >Start date<span class="required">*</span></label
          >
          <div class="d-flex align-items-center">
            <DatePicker
              id="startDatePicker"
              v-bind="$attrs"
              v-model="form.startDate"
              format="DD/MM/yyyy"
              lang="en"
              :value="form.startDate"
              @change="
                changeStartDate($event);
                form.startDate = $event;
              "
              class="flex-grow-1"
              style="margin-top: -0.6rem"
            />
            <button
              type="button"
              @click="form.startDate = null"
              class="btn btn-outline-secondary ml-1"
              style="height: calc(100%); white-space: nowrap"
            >
              Clear
            </button>
          </div>
          <div v-if="isSubmit && error.errorStartDate" class="text-error">
            {{ error.errorStartDate.message }}
          </div>
        </div>
        <div class="col-3">
          <label for="endDatePicker" required>End date</label>
          <div class="d-flex align-items-center">
            <DatePicker
              id="endDatePicker"
              v-bind="$attrs"
              v-model="form.endDate"
              :value="form.endDate"
              format="DD/MM/yyyy"
              lang="en"
              :minDate="form.startDate"
              @change="changeEndDate"
              style="margin-top: -0.6rem"
            />
            <button
              type="button"
              @click="form.endDate = null"
              class="btn btn-outline-secondary ml-1"
              style="height: calc(100%); white-space: nowrap"
            >
              Clear
            </button>
          </div>
          <div v-if="isSubmit && error.errorEndDate" class="text-error">
            {{ error.errorEndDate.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="d-flex align-items-center justify-content-start">
            <span>
              <strong>Date created: </strong> &nbsp;
              {{ form.dateCreated }}</span
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="d-flex align-items-center justify-content-start">
            <span>
              <strong>Last updated: </strong> &nbsp;
              {{ form.lastUpdated }}</span
            >
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary text-white" @click="$router.go(-1)">
          Back
        </button>
        <button class="btn btn-outline-success ml-10" @click="onSubmit">
          Save
        </button>
      </div>
    </div>

    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="row text-center">
          <div v-if="showSuccess && id" class="col-12">
            <button class="btn-back" @click="setDefault">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="col-12">
            <button
              class="btn-back"
              @click="() => $router.push({ name: 'ServiceMaster' })"
            >
              กลับสู่หน้าหลัก
            </button>
          </div>
        </div>
        <div v-if="!showSuccess" class="row text-center">
          <div class="col">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown";
import ServiceMasterService from "services/api/serviceMaster.service";
import DatePicker from "components/Datepicker/Datepicker.vue";
import moment from "moment";
import NumberInput from "components/NumberInput/NumberInput.vue";

export default {
  components: {
    NumberInput,
    DatePicker,
    BrandDropdown,
  },

  data() {
    return {
      id: this.$route.query.id,
      message: null,
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      isSubmit: false,
      form: {
        nameTh: null,
        nameEn: null,
        detailTh: null,
        detailEn: null,
        durationInMinutes: null,
        brandSelected: null,
        status: false,
        startDate: null,
        endDate: null,
        dateCreated: null,
        lastUpdated: null,
      },
      error: {
        errorNameTh: "",
        errorNameEn: "",
        errorBrandCode: "",
        errorDuration: "",
        errorStatus: "",
        errorStartDate: "",
        errorEndDate: "",
      },
    };
  },
  async mounted() {
    if (this.id) {
      this.isLoading = true;
      await this.getServiceMasterDetail(this.id);
    }
  },
  computed: {
    durationInMinutes: {
      get() {
        return this.form.durationInMinutes === null
          ? ""
          : this.form.durationInMinutes;
      },
      set(value) {
        this.form.durationInMinutes = value === "" ? null : Number(value);
      },
    },
  },
  methods: {
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      this.showSuccess = false;
      this.resetErrorText();
      const form = this.form;
      const body = {
        brandCode: form.brandSelected?.id,
        nameTh: form.nameTh,
        nameEn: form.nameEn,
        detailTh: form.detailTh,
        detailEn: form.detailEn,
        durationInMinutes: form.durationInMinutes,
        status: form.status ? "ACTIVE" : "INACTIVE",
        startDate: this.convertToISO8601(form.startDate),
        endDate: this.convertToISO8601(form.endDate),
      };
      if (this.id) {
        this.updateServiceMaster(this.id, body);
      } else {
        this.createServiceMaster(body);
      }
    },
    async getServiceMasterDetail() {
      await ServiceMasterService.getDetailServiceMaster(this.id)
        .then((res) => {
          this.isLoading = false;
          this.isUploading = false;
          const data = res.data;
          const form = this.form;
          form.nameTh = data.nameTh;
          form.nameEn = data.nameEn;
          form.detailTh = data.detailTh;
          form.detailEn = data.detailEn;
          form.brandSelected = data.brandCode;
          form.status = data.status === "ACTIVE";
          form.durationInMinutes = data.durationInMinutes;
          form.startDate = this.toBangkokDateTime(data.startDate, "YYYY-MM-DD");
          form.endDate = this.toBangkokDateTime(data.endDate, "YYYY-MM-DD");
          form.dateCreated = this.toBangkokDateTime(
            data.dateCreated,
            "DD/MM/YYYY HH:mm:ss"
          );
          form.lastUpdated = this.toBangkokDateTime(
            data.lastUpdated,
            "DD/MM/YYYY HH:mm:ss"
          );
        })
        .catch((err) => {
          this.requestFailure(err);
        });
    },
    async createServiceMaster(body) {
      this.isLoading = true;
      try {
        await ServiceMasterService.createServiceMaster(body).then((res) => {
          this.createOrUpdateSuccess(res);
        });
      } catch (error) {
        this.requestFailure(error);
      }
    },
    async updateServiceMaster(id, body) {
      this.isLoading = true;
      try {
        await ServiceMasterService.updateServiceMaster(id, body).then((res) => {
          this.createOrUpdateSuccess(res);
        });
      } catch (error) {
        this.requestFailure(error);
      }
    },
    createOrUpdateSuccess(result) {
      this.isLoading = false;
      const data = result.data;
      if (data.message) {
        this.message = data.message;
      } else {
        this.message = "บันทึกสำเร็จ";
      }
      this.showDialog = true;
      const form = this.form;
      if (data.dateCreated) {
        form.dateCreated = this.toBangkokDateTime(
          data.dateCreated,
          "DD/MM/YYYY HH:mm:ss"
        );
      }
      if (data.lastUpdated) {
        form.lastUpdated = this.toBangkokDateTime(
          data.lastUpdated,
          "DD/MM/YYYY HH:mm:ss"
        );
      }
      this.showSuccess = true;
      this.id = data.id;
      this.$router.replace({ query: { ...this.$route.query, id: data.id } });
    },
    requestFailure(err) {
      this.isLoading = false;
      const errorData = err.response?.data;
      if (errorData.errors?.length > 0) {
        this.setErrorText(errorData.errors);
      }
      if (errorData.message) {
        this.message = errorData.message;
      } else {
        this.message = "ไม่สามารถบันทึกได้";
      }
      this.showDialog = true;
    },
    async setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
    setBrand(brand) {
      this.form.brandSelected = brand || "";
    },
    setBrands(brands) {
      brands.forEach((brand) => {
        if (brand.id === this.form.brandSelected) {
          this.form.brandSelected = brand;
        }
      });
    },
    changeStartDate(val) {
      if (val > this.form.endDate) {
        this.form.endDate = null;
      }
    },
    changeEndDate(event) {
      const value = event.target ? event.target.value : event;
      this.form.endDate = value || null;
    },
    toBangkokDateTime(date, format) {
      if (!date) return null;
      return moment(date).utcOffset("+07:00").format(format);
    },
    convertToISO8601(date) {
      if (!date) return null;
      return moment(date, "yyyy-MM-DD").toISOString();
    },
    setErrorText(errors) {
      this.error.errorBrandCode = errors.find(
        (e) => e.fieldName === "brandCode"
      );
      this.error.errorNameTh = errors.find((e) => e.fieldName === "nameTh");
      this.error.errorNameEn = errors.find((e) => e.fieldName === "nameEn");
      this.error.errorStatus = errors.find((e) => e.fieldName === "status");
      this.error.errorStartDate = errors.find(
        (e) => e.fieldName === "startDate"
      );
      this.error.errorEndDate = errors.find((e) => e.fieldName === "endDate");
      this.error.errorDuration = errors.find(
        (e) => e.fieldName === "durationInMinutes"
      );
    },
    resetErrorText() {
      this.error = {
        errorNameTh: "",
        errorNameEn: "",
        errorBrandCode: "",
        errorStatus: "",
        errorDuration: "",
        errorStartDate: "",
        errorEndDate: "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-cancel {
  color: red;

  .btn-cancel:hover {
    color: white;
  }
}
</style>
